import { Check, ChevronDown, CircleCheck, Users } from 'lucide-react';
import type { Language } from './caseStudyData';
import { copy } from './marketingContent';
import { StartupDirectory } from './StartupPages';

export function JourneyPreview({ language }: { language: Language }) {
  const text = copy[language].preview;
  return <div className="hero-visual" aria-label={text.label}>
    <div className="orb orb-one" /><div className="orb orb-two" />
    <div className="dashboard-card journey-preview">
      <span className="example-label">{text.label}</span>
      <h2>{text.title}</h2><p className="preview-status"><CircleCheck size={16} aria-hidden="true" />{text.status}</p>
      <ol className="preview-steps">{text.rows.map(([role, action], index) => <li key={role}><span className="preview-number" aria-hidden="true">{index + 1}</span><div><strong>{role}</strong><p>{action}</p></div><Check size={16} aria-hidden="true" /></li>)}</ol>
      <p className="preview-note">{text.note}</p>
    </div>
  </div>;
}

export function SolutionsSection({ language }: { language: Language }) {
  return <StartupDirectory language={language} />;
}

export function CapabilitiesSection({ language }: { language: Language }) {
  const text = copy[language].capabilities;
  return <section className="capabilities-section section-shell" id="Capabilities" aria-labelledby="capabilities-heading">
    <div className="section-heading"><div><span className="eyebrow">{text.label}</span><h2 id="capabilities-heading">{text.title}</h2><p className="section-intro">{text.intro}</p></div></div>
    <div className="capability-grid">{text.items.map(([title, description, example], index) => <details className="capability-card" key={index}><summary><span className="capability-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span><h3>{title}</h3><ChevronDown size={18} aria-hidden="true" /></summary><div className="capability-body"><p>{description}</p><p className="capability-example"><strong>{text.example}: </strong>{example}</p></div></details>)}</div>
    <p className="capability-note">{text.note}</p>
  </section>;
}

export function RolesSection({ language }: { language: Language }) {
  const text = copy[language].roles;
  return <section className="roles-section section-shell" id="Roles" aria-labelledby="roles-heading"><div className="section-heading"><div><span className="eyebrow">{text.label}</span><h2 id="roles-heading">{text.title}</h2></div></div><div className="role-grid">{text.items.map(([title, description]) => <article key={title}><Users size={23} aria-hidden="true" /><h3>{title}</h3><p>{description}</p></article>)}</div></section>;
}

export function FaqSection({ language }: { language: Language }) {
  const text = copy[language].faq;
  return <section className="faq-section section-shell" id="Resources" aria-labelledby="faq-heading"><div className="section-heading"><div><span className="eyebrow">{text.label}</span><h2 id="faq-heading">{text.title}</h2></div></div><div className="faq-list">{text.items.map(([question, answer], index) => <details key={index}><summary>{question}<ChevronDown size={18} aria-hidden="true" /></summary><p>{answer}</p></details>)}</div></section>;
}
